import { Icon, RelativeTime, type Column } from "@nabble/ui";
import type { Passkey } from "../../../../api/secondFactors";

/** Columns of the passkeys table; `onRemove` is the row's only action. */
export function passkeyColumns(onRemove: (passkey: Passkey) => void): Column<Passkey>[] {
  return [
    {
      key: "label",
      label: "Name",
      minWidth: 200,
      render: (p) => (
        <div className="nb-cell-main">
          <span className="nb-link-card-icon" style={{ width: 28, height: 28 }}>
            <Icon name="key" />
          </span>
          <span className="nb-cell" title={p.label}>
            {p.label}
          </span>
        </div>
      ),
    },
    { key: "createdAt", label: "Registered", type: "date", width: 130 },
    {
      key: "lastUsedAt",
      label: "Last used",
      type: "datetime",
      width: 130,
      render: (p) => <RelativeTime value={p.lastUsedAt} fallback="Never" />,
    },
    {
      key: "actions",
      label: "Actions",
      type: "actions",
      width: 56,
      actions: (p) => [{ label: `Remove ${p.label}`, icon: "trash", tone: "danger", inline: true, onSelect: () => onRemove(p) }],
    },
  ];
}
